import React from 'react';
import { Card, CardContent } from './Card';
import { formatCurrency } from '../../lib/utils';

/**
 * Carte statistique animée avec icône, valeur, tendance et mini-graphique optionnel
 */
const StatCard = ({ 
  title, 
  value, 
  icon, 
  gradient = 'from-blue-500 to-blue-600',
  trend = null,
  trendValue = null,
  subtitle = null,
  sparklineData = null,
  onClick = null
}) => {
  return (
    <Card 
      className={`bg-gradient-to-br ${gradient} text-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-${onClick ? 'pointer' : 'default'}`}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-white/80 text-sm font-medium mb-2">{title}</p>
            <p className="text-3xl font-bold mb-1">
              {typeof value === 'number' && title.toLowerCase().includes('montant') || title.toLowerCase().includes('solde') || title.toLowerCase().includes('coût')
                ? formatCurrency(value) 
                : value}
            </p>
            {subtitle && (
              <p className="text-white/70 text-xs mt-1">{subtitle}</p>
            )}
            
            {/* Tendance */}
            {trend && (
              <div className={`flex items-center mt-2 text-sm ${
                trend === 'up' ? 'text-green-200' : 
                trend === 'down' ? 'text-red-200' : 
                'text-white/70'
              }`}>
                <span className="mr-1">
                  {trend === 'up' ? '↗️' : trend === 'down' ? '↘️' : '→'}
                </span>
                <span>{trendValue || 'Stable'}</span>
              </div>
            )}
          </div>
          
          {/* Icône */}
          <div className="text-4xl opacity-80 animate-pulse">{icon}</div>
        </div>
        
        {/* Mini sparkline */}
        {sparklineData && sparklineData.length > 0 && (
          <div className="mt-3 h-12">
            <svg width="100%" height="100%" className="opacity-50">
              <polyline
                fill="none"
                stroke="white"
                strokeWidth="2"
                points={generateSparklinePoints(sparklineData)}
              />
            </svg>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

// Génère les points pour le sparkline
const generateSparklinePoints = (data) => {
  if (!data || data.length === 0) return '';
  
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  
  const width = 100;
  const height = 100;
  const step = width / (data.length - 1 || 1);
  
  return data
    .map((value, index) => {
      const x = index * step;
      const y = height - ((value - min) / range) * height;
      return `${x},${y}`;
    })
    .join(' ');
};

export default StatCard;
